import React, { FC, useState } from 'react';
import { Box, Text, SegmentedControl, SegmentedControlOption } from '@bechtel/gds';
import { OwnershipLevel } from '@bechtel/types';
import { Trans } from '@lingui/macro';

export const Ownership: FC = () => {
  const [selectedOwnershipLevel, setSelectedOwnershipLevel] = useState<OwnershipLevel>(OwnershipLevel.PRIMARY);
  return (
    <Box alignItems={{ sm: 'center' }} style={{ opacity: '0.5', pointerEvents: 'none' }}>
      <Text size="300" color="grey.1000" weight="600">
        <Trans>Ownership Level:</Trans>
      </Text>
      &nbsp;&nbsp;
      {/* TODO: One-off segmented control style with height of button not matching GDS. Hence styled inline. Move
        button style to GDS if this height is used in other places  */}
      <SegmentedControl style={{ width: '248px' }}>
        <SegmentedControlOption
          selected={selectedOwnershipLevel === OwnershipLevel.PRIMARY}
          onClick={() => setSelectedOwnershipLevel(OwnershipLevel.PRIMARY)}
          style={{ height: '22px' }}
        >
          <Trans>Primary</Trans>
        </SegmentedControlOption>
        <SegmentedControlOption
          selected={selectedOwnershipLevel === OwnershipLevel.SECONDARY}
          onClick={() => setSelectedOwnershipLevel(OwnershipLevel.SECONDARY)}
          style={{ height: '22px' }}
        >
          <Trans>Secondary</Trans>
        </SegmentedControlOption>
        <SegmentedControlOption
          selected={selectedOwnershipLevel === OwnershipLevel.ALL}
          onClick={() => setSelectedOwnershipLevel(OwnershipLevel.ALL)}
          style={{ height: '22px' }}
        >
          <Trans>All</Trans>
        </SegmentedControlOption>
      </SegmentedControl>
    </Box>
  );
};
